<!-- Form row -->
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">

        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <form [formGroup]="basicWizardForm" #basicForm="ngForm" *ngIf="loaded && !submitted"
          style="padding-bottom: 30px;">

          <div class="row" formGroupName="datos">

            <div class="col-md-12 mb-1">
              <h4 class="header-title"><span i18n>Filtros de búsqueda</span></h4>
              <!--<p>Campos con valor "N/A" no aplicarán filtrado, es decir, equivaldría a seleccionar TODOS los valores de
                dicho campo.</p>-->
            </div>

            <div class="col-md-4 mb-3">
              <label for="inputSectores" class="form-label" i18n>Sectores</label>
              <select2 [data]="sectores" i18n-placeholder="@@inputSectoresPlaceholder" placeholder="N/A" id="inputSectores" multiple="true" #country2
                displaySearchStatus="always" noLabelTemplate="true" formControlName="sectores">
              </select2>
            </div>

            <div class="col-md-4 mb-3">
              <label for="inputNacionalidad" class="form-label" i18n>Nacionalidad/es</label>
              <select2 [data]="nacionalidades" placeholder="N/A" id="inputNacionalidad" multiple="true" #country2
                displaySearchStatus="always" noLabelTemplate="true" formControlName="nacionalidades">
              </select2>
              <div class="form-check" style="margin-top: 5px;">
                <input type="checkbox" class="form-check-input" id="inputinvertirNacionalidades"
                  formControlName="invertirNacionalidades">
                <label class="form-check-label" for="inputinvertirNacionalidades" i18n>Invertir filtro</label>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <label for="inputSistemasJuridico" class="form-label" i18n>Sistemas jurídicos</label>
              <select2 [data]="sistemasJuridicos" i18n-placeholder="@@inputSistemasJuridicoPlaceholder" placeholder="N/A" id="inputSistemasJuridico" multiple="true" #country2
                formControlName="sistemasJuridicos" displaySearchStatus="always" noLabelTemplate="true">
              </select2>
            </div>

            <div class="col-md-12 mb-2">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="soloCompletados"
                  formControlName="soloCompletados">
                <label class="form-check-label" for="soloCompletados" i18n>Sólo árbitros/as con la experiencia profesional cumplimentada</label>
              </div>
            </div>

            <div class="col-md-2 mb-2">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="es_arbitro"
                  formControlName="es_arbitro">
                <label class="form-check-label" for="es_arbitro" i18n>Árbitros</label>
              </div>
            </div>

            <div class="col-md-2 mb-2">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="es_representante"
                  formControlName="es_representante">
                <label class="form-check-label" for="es_representante" i18n>Representantes</label>
              </div>
            </div>
            


            <div class="col-md-12 mb-3">
              <label for="experiencia" class="form-label" i18n>Experiencia</label>
              <ngb-accordion #acc2="ngbAccordion" class="custom-accordion" id="experiencia" [activeIds]="openIds">

                <ngb-panel id="customAccordion1" cardClass="mb-0">
                  <ng-template ngbPanelTitle>
                    <h5 class="m-0 position-relative">
                      <a href="javascript:void(0)" class="custom-accordion-title text-reset d-block">
                        <span i18n>Arbitraje internacional - CIIAM</span>
                      </a>
                    </h5>
                    <i class="mdi mdi-chevron-down accordion-arrow"></i>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="card-body">
                      <div class="row">
                        <!-- Presidente del tribunal -->
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_ciam_presidente" class="form-label" i18n>Presidente del
                            tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_ciam_presidente"
                            name="exp_internacional_ciam_presidente"
                            formControlName="exp_internacional_ciam_presidente">
                          </select2>
                        </div>
                        <!-- Árbitro único -->
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_ciam_arbitro_unico" class="form-label" i18n>Árbitro único</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_ciam_arbitro_unico"
                            name="exp_internacional_ciam_arbitro_unico"
                            formControlName="exp_internacional_ciam_arbitro_unico">
                          </select2>
                        </div>
                        <!-- Co-árbitro -->
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_ciam_coarbitro" class="form-label" i18n>Co-árbitro</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_ciam_coarbitro"
                            name="exp_internacional_ciam_coarbitro" formControlName="exp_internacional_ciam_coarbitro">
                          </select2>
                        </div>
                        <!-- Letrado de parte -->
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_ciam_letrado" class="form-label" i18n>Letrado de parte</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_ciam_letrado"
                            name="exp_internacional_ciam_letrado" formControlName="exp_internacional_ciam_letrado">
                          </select2>
                        </div>
                        <!-- Secretario del tribunal -->
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_ciam_secretario" class="form-label" i18n>Secretario del Tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_ciam_secretario"
                            name="exp_internacional_ciam_secretario"
                            formControlName="exp_internacional_ciam_secretario">
                          </select2>
                        </div>
                        <!-- Árbitro de emergencia -->
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_ciam_arbitro_emergencia" class="form-label" i18n>Árbitro de
                            emergencia</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_ciam_arbitro_emergencia"
                            name="exp_internacional_ciam_arbitro_emergencia"
                            formControlName="exp_internacional_ciam_arbitro_emergencia">
                          </select2>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="customAccordion2" cardClass="mb-0">
                  <ng-template ngbPanelTitle>
                    <h5 class="m-0 position-relative">
                      <a href="javascript:void(0)" class="custom-accordion-title text-reset d-block">
                        <span i18n>Arbitraje internacional - Otra institución</span>
                      </a>
                    </h5>
                    <i class="mdi mdi-chevron-down accordion-arrow"></i>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_otra_presidente" class="form-label" i18n>Presidente del
                            tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_otra_presidente"
                            name="exp_internacional_otra_presidente"
                            formControlName="exp_internacional_otra_presidente">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_otra_arbitro_unico" class="form-label" i18n>Árbitro único</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_otra_arbitro_unico"
                            name="exp_internacional_otra_arbitro_unico"
                            formControlName="exp_internacional_otra_arbitro_unico">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_otra_coarbitro" class="form-label" i18n>Co-árbitro</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_otra_coarbitro"
                            name="exp_internacional_otra_coarbitro" formControlName="exp_internacional_otra_coarbitro">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_otra_letrado" class="form-label" i18n>Letrado de parte</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_otra_letrado"
                            name="exp_internacional_otra_letrado" formControlName="exp_internacional_otra_letrado">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_otra_secretario" class="form-label" i18n>Secretario del
                            tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_otra_secretario"
                            name="exp_internacional_otra_secretario"
                            formControlName="exp_internacional_otra_secretario">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_otra_arbitro_emergencia" class="form-label" i18n>Árbitro de
                            emergencia</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_otra_arbitro_emergencia"
                            name="exp_internacional_otra_arbitro_emergencia"
                            formControlName="exp_internacional_otra_arbitro_emergencia">
                          </select2>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="customAccordion3" cardClass="mb-0">
                  <ng-template ngbPanelTitle>
                    <h5 class="m-0 position-relative">
                      <a href="javascript:void(0)" class="custom-accordion-title text-reset d-block">
                        <span i18n>Arbitraje internacional - Ad Hoc</span>
                      </a>
                    </h5>
                    <i class="mdi mdi-chevron-down accordion-arrow"></i>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_adhoc_presidente" class="form-label" i18n>Presidente del
                            tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_adhoc_presidente"
                            name="exp_internacional_adhoc_presidente"
                            formControlName="exp_internacional_adhoc_presidente">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_adhoc_arbitro_unico" class="form-label" i18n>Árbitro único</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_adhoc_arbitro_unico"
                            name="exp_internacional_adhoc_arbitro_unico"
                            formControlName="exp_internacional_adhoc_arbitro_unico">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_adhoc_coarbitro" class="form-label" i18n>Co-árbitro</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_adhoc_coarbitro"
                            name="exp_internacional_adhoc_coarbitro"
                            formControlName="exp_internacional_adhoc_coarbitro">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_adhoc_letrado" class="form-label" i18n>Letrado de parte</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_adhoc_letrado"
                            name="exp_internacional_adhoc_letrado" formControlName="exp_internacional_adhoc_letrado">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_adhoc_secretario" class="form-label" i18n>Secretario del
                            tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_adhoc_secretario"
                            name="exp_internacional_adhoc_secretario"
                            formControlName="exp_internacional_adhoc_secretario">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_internacional_adhoc_arbitro_emergencia" class="form-label" i18n>Árbitro de
                            emergencia</label>
                          <select2 [data]="experienciaOpciones" id="exp_internacional_adhoc_arbitro_emergencia"
                            name="exp_internacional_adhoc_arbitro_emergencia"
                            formControlName="exp_internacional_adhoc_arbitro_emergencia">
                          </select2>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="customAccordion4" cardClass="mb-0">
                  <ng-template ngbPanelTitle>
                    <h5 class="m-0 position-relative">
                      <a href="javascript:void(0)" class="custom-accordion-title text-reset d-block">
                        <span i18n>Arbitraje nacional - Institucional</span>
                      </a>
                    </h5>
                    <i class="mdi mdi-chevron-down accordion-arrow"></i>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_institucional_presidente" class="form-label" i18n>Presidente del
                            tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_institucional_presidente"
                            name="exp_nacional_institucional_presidente"
                            formControlName="exp_nacional_institucional_presidente">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_institucional_arbitro_unico" class="form-label" i18n>Árbitro único</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_institucional_arbitro_unico"
                            name="exp_nacional_institucional_arbitro_unico"
                            formControlName="exp_nacional_institucional_arbitro_unico">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_institucional_coarbitro" class="form-label" i18n>Co-árbitro</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_institucional_coarbitro"
                            name="exp_nacional_institucional_coarbitro"
                            formControlName="exp_nacional_institucional_coarbitro">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_institucional_letrado" class="form-label" i18n>Letrado de parte</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_institucional_letrado"
                            name="exp_nacional_institucional_letrado"
                            formControlName="exp_nacional_institucional_letrado">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_institucional_secretario" class="form-label" i18n>Secretario del
                            tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_institucional_secretario"
                            name="exp_nacional_institucional_secretario"
                            formControlName="exp_nacional_institucional_secretario">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_institucional_arbitro_emergencia" class="form-label" i18n>Árbitro de
                            emergencia</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_institucional_arbitro_emergencia"
                            name="exp_nacional_institucional_arbitro_emergencia"
                            formControlName="exp_nacional_institucional_arbitro_emergencia">
                          </select2>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="customAccordion5" cardClass="mb-0">
                  <ng-template ngbPanelTitle>
                    <h5 class="m-0 position-relative">
                      <a href="javascript:void(0)" class="custom-accordion-title text-reset d-block">
                        <span i18n>Arbitraje nacional - Ad Hoc</span>
                      </a>
                    </h5>
                    <i class="mdi mdi-chevron-down accordion-arrow"></i>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_adhoc_presidente" class="form-label" i18n>Presidente del tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_adhoc_presidente"
                            name="exp_nacional_adhoc_presidente" formControlName="exp_nacional_adhoc_presidente">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_adhoc_arbitro_unico" class="form-label" i18n>Árbitro único</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_adhoc_arbitro_unico"
                            name="exp_nacional_adhoc_arbitro_unico" formControlName="exp_nacional_adhoc_arbitro_unico">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_adhoc_coarbitro" class="form-label" i18n>Co-árbitro</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_adhoc_coarbitro"
                            name="exp_nacional_adhoc_coarbitro" formControlName="exp_nacional_adhoc_coarbitro">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_adhoc_letrado" class="form-label" i18n>Letrado de parte</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_adhoc_letrado"
                            name="exp_nacional_adhoc_letrado" formControlName="exp_nacional_adhoc_letrado">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_adhoc_secretario" class="form-label" i18n>Secretario del tribunal</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_adhoc_secretario"
                            name="exp_nacional_adhoc_secretario" formControlName="exp_nacional_adhoc_secretario">
                          </select2>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label for="exp_nacional_adhoc_arbitro_emergencia" class="form-label" i18n>Árbitro de
                            emergencia</label>
                          <select2 [data]="experienciaOpciones" id="exp_nacional_adhoc_arbitro_emergencia"
                            name="exp_nacional_adhoc_arbitro_emergencia"
                            formControlName="exp_nacional_adhoc_arbitro_emergencia">
                          </select2>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>

              </ngb-accordion>
            </div>


          </div>

          <div class="row">
            <div class="col-md-4 mb-3"></div>
            <div class="col-md-4 mb-3">
              <div class="button-list pe-xl-4 d-grid">
                <button type="submit" class="btn btn--md btn-primary waves-effect waves-light"
                  (click)="onSubmit()"><span i18n>Filtrar Árbitros</span></button>
              </div>
            </div>
            <div class="col-md-4 mb-3"></div>
          </div>
        </form>

        <div class="col-md-12 mb-3" *ngIf="loaded">
          <div class="col-md-12 mb-3" *ngIf="submitted">
            <h4 class="header-title"><span i18n>Lista de Árbitros filtrados</span></h4>
          </div>

          <app-advanced-table *ngIf="!filtrando && !error && submitted" [tableData]="records" [columns]="columns"
            [pagination]="true" [pageSizeOptions]="pageSizeOptions" [hasRowSelection]="true" [isSearchable]="true"
            (search)="searchData($event)" [isSortable]="true" (sort)="onSort($event)" [buttonLink]="buttonLink"
            [buttonTitle]="buttonTitle" [nacionalidades]="nacionalidades" [profesiones]="profesiones" [colegiaciones]="colegiaciones" [sectores]="sectores"
            [idiomas]="idiomas" [sistemasJuridicos]="sistemasJuridicos">
          </app-advanced-table>



          <div class="row" *ngIf="!filtrando && submitted">
            <div class="col-md-3 mb-3"></div>
            <div class="col-md-3 mb-3">
              <div class="button-list pe-xl-4 d-grid">
                <button type="submit" class="btn btn--md btn-primary waves-effect waves-light" (click)="volver()"><i class="mdi mdi-keyboard-backspace me-1"></i><span i18n>Volver a filtros</span></button>                
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <div class="button-list pe-xl-4 d-grid">
                <button type="button" class="btn btn--md btn-primary waves-effect waves-light" (click)="exportToXlsx('arbitros', records)"><i class="mdi mdi-cloud-download-outline me-1"></i><span i18n>Exportar a XLSX</span></button>
              </div>
            </div>
            <div class="col-md-3 mb-3">
            </div>
          </div>

          <div class="spinner" *ngIf="filtrando && !error">
            <div></div>
            <div></div>
            <div></div>
          </div>


        </div>

      </div> <!-- end card-body -->
    </div> <!-- end card-->
  </div> <!-- end col -->
</div>
<!-- end row -->